import React from 'react';
var Row = function (_a) {
    var children = _a.children, gap = _a.gap;
    gap = gap || 0;
    return React.createElement("div", { style: { display: 'flex' } }, Array.isArray(children) ?
        children.map(function (child, index) { return React.createElement("div", { key: index, style: { margin: "0 " + gap * 10 + "px" } }, child); })
        : children);
};
export default Row;
//# sourceMappingURL=Row.js.map